import { initOrganizationRequestsChart } from "./initOrganizationRequestsChart";

export const organizationRequestsChart = {
  initOrganizationRequestsChart,
};
